import { ActionTree, ActionContext } from 'vuex'
import { SearchState } from './state'

const actions: ActionTree<SearchState, {}> = {
  setQuery: (context: ActionContext<SearchState, {}>, query: string) => {
    context.commit('SEARCH_QUERY_UPDATED', query)
  },
}

export default actions
